import photoList from './src/main.vue';
import { withInstall } from '../../utils';
export const PhotoList = withInstall(photoList);
export default PhotoList;
